import React, { Component } from 'react';
import './App.css';
import Today from './Today/Today';

class App extends Component {
  render() {
    return (
      <div className='App'>
        <h1>Jovellanos</h1>
        <Today />
      </div>
    );
  }
}

export default App;
